// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"ReduxLoader__spinnerContainer___uELOP","errorContainer":"ReduxLoader__errorContainer___z3Cc3","errorIcon":"ReduxLoader__errorIcon___VNQIi"};